import { capitalize } from 'lodash'
import { getRequest } from '.'

export const getSearchResults = async <T>(
  terms: string,
  type: 'internal' | 'external',
  realmScope?: wowaudit.Realm,
  searchType?: 'character' | 'guild' | 'community',
): Promise<T[]> => {
  const params = new URLSearchParams({
    terms,
    ...(realmScope && { realm_id: realmScope.id.toString() }),
    ...(searchType && { type: searchType }),
  })

  return await getRequest(
    type === 'internal'
      ? `/api/search?${params.toString()}`
      : `/api/search/blizzard?${params.toString()}`,
  )
}

export const getEntityFromBlizzard = async (
  name: string,
  realmName: string,
  region: string,
  type: 'character' | 'guild',
) => {
  return await getRequest(
    `/api/search/blizzard?terms=${name}&realm_name=${realmName}&region=${region}&type=${capitalize(
      type,
    )}`,
  )
}
